// extracted by mini-css-extract-plugin
export default {"active":"RequestTable_active__l4Sa2","inactive":"RequestTable_inactive__mbCRu","revoked":"RequestTable_revoked__k4vvU"};